import React from "react";
import { useSelector } from "react-redux";
import { Rating } from "react-simple-star-rating";
import { arrow, user } from "../../constant";
import { ramdomImage } from "../../constant/ConstantFunction";
import DonarListModal from "../../Components/Modal/DonarListModal";


function ReviewBox(props) {
	const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);
	const userData = useSelector((state) => state.AuthReducer.users);
	const {
		handleRating,
		rating,
		SubmitRating,
		comment,
		setComment,
		reviewLoading,
	} = props;
	return (
		<>
			<section className="leave_comment">
				<div className="container">
					<div className="row">
						<div className="col-lg-12 col-md-12">
							<form action="">
								<div className="row">
									<div className="col-lg-6 review-user-send mb-3 mt-3">
										{userData?.image == null ? null :
											<div className="user-imgCont">
												<img
													src={`${ImageUrlRedux?.customer_image_url}/${userData.image}`}
													className="img-fluid"
												/>
											</div>
										}
										<div>
											{" "}
											<p className="user-name ml-3 mb-3">  {userData?.f_name} {userData?.l_name}</p>
											<p className="user-about ml-3">
												Your review will be Posted on Web
											</p>
										</div>
									</div>
									<div className="col-lg-6 mb-3 mt-3">
										<div className="form-group post-star-cont">
											<Rating allowFraction={true} onClick={handleRating} ratingValue={rating} />
										</div>
									</div>

									<div className="col-md-12">
										<div className="form-group">
											<textarea
												className="form-control"
												placeholder="Write Your Review Here"
												value={comment}
												onChange={(e) => setComment(e.target.value)}
											></textarea>
										</div>
									</div>
									<div className="col-lg-6">
										<div>
											<button className="btn SubmitReview"
												onClick={(e) => SubmitRating(e)}
												disabled={reviewLoading}
											>
												{reviewLoading ? "Loading..." : "Submit review"}{" "}
												<img src={arrow} alt="" className="image-fluid" />
											</button>
										</div>
									</div>
								</div>
							</form>
						</div>
						<div className="col-md-4"></div>
					</div>
				</div>
			</section>
		</>
	);
}

export default ReviewBox;
